module.exports = __webpack_public_path__ + "static/media/food_beach_1.f4d00ffe.svg";